import { render, staticRenderFns } from "./goalBuilder.vue?vue&type=template&id=2d01e835&"
import script from "./goalBuilder.vue?vue&type=script&lang=js&"
export * from "./goalBuilder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports